import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Course from '../Course'
import FolkhogskolaContent from './Content'
import AppSidebar from '../../../Layout/AppSidebar'


const Folkhogskola = ({ match }) => {
	return (
		<React.Fragment>
			<div className="app-main">
				<AppSidebar schoolTypeId={'folkhogskola'}/>
				<div className="app-main__outer">
					<div className="app-main__inner">
						<Switch>
							<Route path={`${match.url}/:subject/:course/:area/:id`} component={Course} />
							<Route path='*' component={FolkhogskolaContent}/>
						</Switch>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default Folkhogskola